/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IBreadcrumbViewProps } from '@msdyn365-commerce-modules/breadcrumb';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import React from 'react';

const BreadCrumbView: React.FC<IBreadcrumbViewProps> = props => {
    const {
        root,
        links,
        backButton,
        BreadcrumbContainer,
        BreadcrumbList,
        BreadcrumbListItem,
        separator,
        data: {
            categoryPaths: { result }
        }
    } = props;

    if (!root && !links && !backButton) {
        props.context.telemetry.error('BreadCrumb content is empty, module wont render');
        return null;
    }

    const pageUrl = props.context.request.url.requestUrl.href.toString();
    return (
        <Module {...BreadcrumbContainer}>
            <Node {...BreadcrumbList}>
                {root && (
                    <Node {...BreadcrumbListItem}>
                        {root}
                        {links && separator}
                    </Node>
                )}
                {backButton && <Node {...BreadcrumbListItem}>{backButton}</Node>}
                {links &&
                    links.map((link, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Node
                                    {...BreadcrumbListItem}
                                    className={classnames(
                                        BreadcrumbListItem.className,
                                        index === links.length - 1 ? 'breadcrumb_item-current' : ''
                                    )}
                                >
                                    {link}
                                    {links[index + 1] && separator}
                                </Node>
                            </React.Fragment>
                        );
                    })}
            </Node>
            {/** Node added for schema */}
            <Node className='' vocab='https://schema.org/' typeof='BreadcrumbList'>
                {result && result.length > 0
                    ? result.map((item, index) => {
                          return (
                              <Node tag='span' key={index} property='itemListElement' typeof='ListItem' className=''>
                                  <meta property='position' content={(index + 1)?.toString()} />
                                  {item.hasOwnProperty('Name') && item.Name !== undefined && (
                                      <meta
                                          property='Name'
                                          content={item.Name.split('-')
                                              .join(' ')
                                              .toString()}
                                      />
                                  )}
                                  {item.hasOwnProperty('Url') && item.Url !== undefined && (
                                      <meta property='item' content={pageUrl + item.Url.toString()} />
                                  )}
                              </Node>
                          );
                      })
                    : null}
            </Node>
        </Module>
    );
};

export default BreadCrumbView;
